export const asgardeoConfig = {
  signInRedirectURL: process.env.REACT_APP_SIGN_IN_URL,
  signOutRedirectURL: process.env.REACT_APP_SIGN_OUT_URL,
  clientID: process.env.REACT_APP_ASGARDEO_CLIENT_ID,
  baseUrl: process.env.REACT_APP_ASGARDEO_BASE_URL,
  scope: ['openid', 'email', 'profile'], // Include profile scope for email access
  responseMode: 'query', // Fastest response mode
  responseType: 'code',
  enableLogout: true,
  clockTolerance: 10, // Increased tolerance for clock skew
  validateIDToken: true,
  // Performance optimizations - disable features that cause loops
  enableOIDCSessionManagement: false, // Disable to prevent loops
  enablePKCE: true, // Enable PKCE for better security and performance
  // Cache settings for speed
  enableCache: true,
  cacheTimeout: 600000, // 10 minutes cache timeout
  // Network optimizations
  enableRetry: true,
  retryAttempts: 1, // Minimal retries for speed
  retryDelay: 200, // Very fast retry
  // Prevent authentication loops
  enableSilentSignIn: false, // Disable silent sign-in to prevent loops
  enableAutoSignIn: false, // Disable auto sign-in
  // Token management for speed
  enableTokenRefresh: true,
  tokenRefreshTimeout: 30000, // 30 seconds before token expiry
  // Session management
  enableSessionManagement: false, // Disable to prevent loops
  sessionTimeout: 600000, // 10 minutes session timeout
};
